import { ReactNode } from "react";
import "../css/GlobalStyles.css";
import { LightTheme, ThemeStyle } from "../hooks/useTheme";
import { Colors } from "../utils/colors";
import IOSSwitch from "./IOSSwitch";

type SwitchToggleItemProps = {
  title: string | ReactNode;
  description?: string;
  toggleValue: boolean;
  onChange: () => void;
  icon?: ReactNode;
  theme?: ThemeStyle;
  disabled?: boolean;
  hideToggle?: boolean;
  switchColor?: string;
};

const SwitchToggleItem = (props: SwitchToggleItemProps) => {
  const {
    title,
    description,
    toggleValue,
    onChange,
    theme,
    disabled,
    hideToggle,
    icon,
    switchColor,
  } = props;

  return (
    <div className="AlignedRowSpaced" style={{ gap: 40, width: "100%" }}>
      <div className="AlignedRow" style={{ gap: 10 }}>
        {icon || null}
        <div>
          <div
            style={{
              color:
                theme === undefined || theme === LightTheme
                  ? Colors.BLACK
                  : Colors.WHITE,
              opacity: disabled ? 0.4 : 1,
              fontWeight: "500",
              fontSize: 14,
            }}
          >
            {title}
          </div>
          {description ? (
            <div
              style={{
                paddingTop: 4,
                fontSize: 12,
                fontWeight: "400",
                color: Colors.GRAY1,
                opacity: disabled ? 0.4 : 1,
                width: "100%",
              }}
            >
              {description}
            </div>
          ) : null}
        </div>
      </div>
      {!hideToggle ? (
        <IOSSwitch
          sx={{ m: 1 }}
          checked={toggleValue}
          onChange={onChange}
          disabled={disabled}
          style={{ cursor: disabled ? "auto" : "pointer" }}
          switchColor={switchColor}
        />
      ) : null}
    </div>
  );
};

export default SwitchToggleItem;
